import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StatsCardComponent } from './stats-card.component';

@NgModule({
  declarations: [StatsCardComponent],
  imports: [CommonModule],
  exports: [StatsCardComponent],
})
export class StatsCardModule {}
